import React, { createContext, useContext } from 'react';

// Create context
const TopicContext = createContext();

// Export Provider and useContext hook
export const useTopic = () => {
    return useContext(TopicContext);
}

export const TopicProvider = TopicContext.Provider;
